import React, { useState, useEffect } from 'react';
import { Shield, LayoutGrid, Layers, Key, Edit2, Plus, Save, X, Trash2, Search } from 'lucide-react';
import Layout from '../../component/layout';
import { PostCallWithErrorResponse, PostCallWithErrorResponseReqBody, deleteWithAuthCall, simpleGetCallWithErrorResponse } from '../../api/ApiServices';
import ApiConfig from '../../api/ApiConfig';
import { ToastMsg } from '../TostMsg';
import Pagination from '../../sharedComponent/Pagination';
import NoData from '../../sharedComponent/NoData';
import Loader from '../Loader';


const Modal = ({ isOpen, title, onClose, children }) => {
  if (!isOpen) return null;
  return (
    <>
      <div
        className="modal-backdrop show"
        style={{ backgroundColor: 'rgba(0,0,0,0.4)', backdropFilter: 'blur(4px)', zIndex: 1050 }}
        onClick={onClose}
      ></div>
      <div className="modal show d-block mt-5" tabIndex="-1" style={{ zIndex: 1055 }}>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content border-0 rounded-4 shadow-lg">
            <div className="modal-header border-0 p-4 pb-0">
              <h5 className="modal-title fw-bold text-dark">{title}</h5>
              <button type="button" className="btn-close shadow-none" onClick={onClose}></button>
            </div>
            <div className="modal-body p-4">
              {children}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};


const PermissionManagement = () => {
  // --- UI STATE ---
  const [activeTab, setActiveTab] = useState('module');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [dropDownData, setDropDownData] = useState([])

  const [data, setData] = useState([])
  const [isAdding, setIsAdding] = useState(false)
  const [search, setSearch] = useState("")

  const [perPageData, setPerPageData] = useState(25)
  const [currentPage, setCurrentPage] = useState(0)
  const startIndex = currentPage * perPageData;
  const endIndex = startIndex + parseInt(perPageData);
  const [isLoading, setIsLoading] = useState(false)


  let initial = {
    id: 0,
    "name": "",
    "description": "",
    "parentName": ""
  }


  const [addEditPerm, setAddEditPerm] = useState(initial)
  const [validated, setValidated] = useState(false);

  const closeModal = () => {

    setValidated(false);
    setAddEditPerm(initial)
    setIsModalOpen(false);
    setIsAdding(false)


  };

  useEffect(() => {

    getData(null, true)

  }, [activeTab])

  const getData = (type = null, isLoading = false) => {

    let module = type ? type : activeTab;

    setIsLoading(isLoading)

    simpleGetCallWithErrorResponse(ApiConfig.GET_MANAGE_PERMISSIONS + module).then((res) => {

      if (res?.json?.success) {

        if (type) {
          setDropDownData(res?.json?.data)
        } else {

          setData(res?.json?.data)
        }


      } else {
        setData([])
      }

      setIsLoading(false)

    })

  }


  // --- HANDLERS: MODULE ---
  const handleSaveModule = (e) => {


    e.preventDefault();
    const form = e.currentTarget;

    if (!form.checkValidity()) {
      e.stopPropagation();
      setValidated(true);
      return;
    }

    if (addEditPerm?.id) return
    setIsAdding(true)



    addEditPerm.type = activeTab
    addEditPerm.name = addEditPerm?.name?.trim();



    PostCallWithErrorResponse(ApiConfig?.ADD_UPDATE_PERMISSIONS, JSON.stringify(addEditPerm)).then((res) => {

      if (res?.json?.success) {
        getData()
        closeModal();
        ToastMsg('success', res?.json?.message)
      } else {
        ToastMsg('error', res?.json?.message)
      }

      setIsAdding(false)

    })


  };


  const handleDelete = (id) => {

    deleteWithAuthCall(ApiConfig.DELETE_PERMISSION + id).then((res) => {



      if (res?.success) {
        getData()
        ToastMsg('success', res?.message)
      } else {

        ToastMsg('error', res?.message)

      }

    })

  }


  const renderToolbar = (title, onAdd, search, setSearch) => (
    <>
      <div className="d-flex justify-content-between align-items-center bg-white p-2 rounded shadow-sm mb-4">
        <h5 className="mb-0 fw-bold px-2 text-dark d-flex align-items-center">{title}</h5>
        <button style={{ color: "#53b7e8", border: "1px solid #53b7e8" }} className="btn rounded px-1 fw-medium d-flex align-items-center bg-white" onClick={onAdd}>
          <Plus size={16} className="me-1" /> Add {title}
        </button>
      </div>

      <div className="d-flex justify-content-between align-items-center mb-3">
        <div className="d-flex gap-3 align-items-center">
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              width: '190px',
              backgroundColor: '#ffffff',
              borderRadius: '5px',
              padding: '0px 5px',
              boxShadow: '0 1px 3px rgba(0,0,0,0.1)' // Soft shadow without border
            }}
          >
            {/* Icon - No border, No bg */}
            <div style={{ color: '#6c757d', display: 'flex', alignItems: 'center' }}>
              <Search size={16} />
            </div>

            {/* Input - Completely reset */}
            <input
              type="text"
              placeholder={`Search ${title}`}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{
                border: 'none',
                outline: 'none',
                background: 'transparent',
                width: '100%',
                padding: '8px 10px',
                fontSize: '14px',
                color: '#333'
              }}
            />
          </div>
          <div className="d-flex align-items-center gap-2">
            <span className="text-muted small">Entries per page</span>
            <select className="form-select rounded border-0 shadow-sm text-dark small" style={{ width: '80px' }}
              value={perPageData}
              onChange={(e) => setPerPageData(e.target.value)}
            >
              <option
                value={'25'}
              >25</option>
              <option
                value={'50'}
              >50</option>
              <option
                value={'75'}
              >75</option>
              <option
                value={'100'}
              >100</option>
            </select>
          </div>
        </div>

      </div>
    </>
  );

  let filterdData = data?.filter(d => d?.module?.toLowerCase().includes(search.toLowerCase()) || d?.submodule?.toLowerCase().includes(search.toLowerCase()) || d?.permission?.toLowerCase().includes(search.toLowerCase()))


  return (
    <Layout>
      <div className=" font-sans" style={{ fontFamily: 'system-ui, -apple-system, sans-serif' }}>

        {/* Main Content Area */}
        <div className="container-fluid py-4">


          {/* Tab Navigation */}
          <div className="d-flex mb-4 gap-3">
            {['module', 'submodule', 'permission'].map((tab) => (
              <button
                key={tab}
                className={`btn rounded px-4 py-2 fw-medium border-0 shadow-sm transition-all ${activeTab === tab ? 'text-white' : 'bg-white text-dark'
                  }`}
                style={{
                  backgroundColor: activeTab === tab ? '#53b7e8' : '#ffffff'
                }}
                onClick={() => {
                  setActiveTab(tab)
                  setSearch("")
                  setCurrentPage(0)
                }}
              >
                {tab.charAt(0).toUpperCase() + tab.slice(1).replace('module', ' Module')}s
              </button>
            ))}
          </div>


          {/* --- TABLES --- */}
          {
            isLoading ?
              <Loader />
              :
              <>


                {activeTab === 'module' && (
                  <>
                    {renderToolbar('Module', () => setIsModalOpen(true), search, setSearch)}
                    <div className="table-responsive rounded" style={{ maxHeight: 'calc(100vh - 390px)', overflowY: 'auto' }}>
                      <table className="table" style={{ borderCollapse: 'separate', borderSpacing: '0 8px' }}>
                        <thead style={{ position: 'sticky', top: 0, zIndex: 10, backgroundColor: 'white' }}>
                          <tr>
                            <th className="border-0 py-2 text-dark px-4" style={{ width: '10%', backgroundColor: 'white' }}>Sr. no</th>
                            <th className="border-0 py-2 text-dark" style={{ width: '60%', backgroundColor: 'white' }}>Module Name</th>
                            <th className="border-0 py-2 text-dark px-4" style={{ width: '30%', backgroundColor: 'white' }}>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filterdData?.slice(startIndex, endIndex)?.map((mod, index) => (
                            <tr key={index} className="shadow-sm">
                              <td className="bg-white border-0 py-2 px-4 rounded-start-1 text-muted">{currentPage * perPageData + index + 1}</td>
                              <td className="bg-white border-0 py-2 text-dark fw-medium">{mod?.module}</td>
                              <td className="bg-white border-0 py-2 px-4 rounded-end-1">
                                <button onClick={() => {
                                  setAddEditPerm({
                                    "name": mod?.module,
                                    "description": "",
                                    "parentName": mod?.module
                                  })
                                  setIsModalOpen(true);
                                }} className="btn btn-link text-primary p-0 me-3"><Edit2 size={16} /></button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </>
                )}


                {activeTab === 'submodule' && (
                  <>
                    {renderToolbar('Sub Module', () => {
                      getData('module')
                      setIsModalOpen(true)
                    }, search, setSearch)}
                    <div className="table-responsive" style={{ maxHeight: 'calc(100vh - 390px)', overflowY: 'auto' }}>
                      <table className="table" style={{ borderCollapse: 'separate', borderSpacing: '0 8px' }}>
                        <thead style={{ position: 'sticky', top: 0, zIndex: 10, backgroundColor: 'white' }}>
                          <tr>
                            <th className="border-0 py-2 bg-white text-dark px-4 py-2" style={{ width: '10%' }}>Sr. no</th>
                            <th className="border-0 py-2 bg-white text-dark py-2" style={{ width: '40%' }}>Sub Module</th>
                            <th className="border-0 py-2 bg-white text-dark py-2" style={{ width: '30%' }}>Parent Module</th>
                            <th className="border-0 py-2 bg-white text-dark px-4 py-2" style={{ width: '20%' }}>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filterdData?.slice(startIndex, endIndex)?.map((sm, index) => (
                            <tr key={sm.id} className="shadow-sm">
                              <td className="bg-white border-0 py-2 px-4 rounded-start-1 text-muted">{currentPage * perPageData + index + 1}</td>
                              <td className="bg-white border-0 py-2 text-dark fw-medium">{sm?.submodule}</td>
                              <td className="bg-white border-0 py-2text-secondary">{sm?.module}</td>
                              <td className="bg-white border-0 py-2 px-4 rounded-end-1">
                                <button
                                  onClick={() => {
                                    getData('module')
                                    setAddEditPerm({
                                      id: sm?.id,
                                      "name": sm?.submodule,
                                      "description": "",
                                      "parentName": sm?.module
                                    })
                                    setIsModalOpen(true);
                                  }}
                                  className="btn btn-link text-primary p-0 me-3"><Edit2 size={16} /></button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </>
                )}


                {activeTab === 'permission' && (
                  <>
                    {renderToolbar('Permission', () => {
                      getData('submodule')
                      setIsModalOpen(true)
                    }, search, setSearch)}
                    <div className="table-responsive" style={{ maxHeight: 'calc(100vh - 390px)', overflowY: 'auto' }}>
                      <table className="table" style={{ borderCollapse: 'separate', borderSpacing: '0 8px' }}>
                        <thead style={{ position: 'sticky', top: 0, zIndex: 10, backgroundColor: 'white' }}>
                          <tr>
                            <th className="border-0 py-2 bg-white text-dark px-4 py-2" style={{ width: '10%' }}>Sr. no</th>
                            <th className="border-0 py-2 bg-white text-dark py-2" style={{ width: '30%' }}>Permission</th>
                            <th className="border-0 py-2 bg-white text-dark py-2" style={{ width: '20%' }}>Module</th>
                            <th className="border-0 py-2 bg-white text-dark py-2" style={{ width: '20%' }}>Sub Module</th>
                            <th className="border-0 py-2 bg-white text-dark px-4 py-2" style={{ width: '20%' }}>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filterdData?.slice(startIndex, endIndex)?.map((perm, index) => (
                            <tr key={perm.id} className="shadow-sm">
                              <td className="bg-white border-0 py-2 px-4 rounded-start-1 text-muted">{currentPage * perPageData + index + 1}</td>
                              <td className="bg-white border-0 py-2 text-dark fw-medium">{perm.permission}</td>
                              <td className="bg-white border-0 py-2 text-secondary">{perm?.module}</td>
                              <td className="bg-white border-0 py-2 text-secondary">{perm.submodule}</td>
                              <td className="bg-white border-0 py-2 px-4 rounded-end-1">
                                <button onClick={() => {
                                  getData('submodule')
                                  setAddEditPerm({
                                    id: perm?.id,
                                    "name": perm?.permission,
                                    "description": "",
                                    "parentName": perm?.submodule
                                  })
                                  setIsModalOpen(true);
                                }} className="btn btn-link text-primary p-0 me-3"><Edit2 size={16} /></button>
                                <button className="btn btn-link text-danger p-0"
                                  onClick={() => handleDelete(perm?.id)}
                                ><Trash2 size={16} /></button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </>
                )}
                <div>
                  <Pagination
                    data={filterdData}
                    usersPerPage={perPageData}
                    currentPage={currentPage}
                    pageChangeHandler={({ selected }) => setCurrentPage(selected)}
                  />
                </div>
              </>
          }
          {
            filterdData?.length == 0 &&
            <NoData />
          }


        </div>


        {/* --- MODAL WINDOW POPUP --- */}
        <Modal
          isOpen={isModalOpen}
          onClose={closeModal}
          title={`${(activeTab == 'module' && addEditPerm.parentName) || addEditPerm?.id ? 'Update' : 'Create'} ${activeTab.charAt(0).toUpperCase() + activeTab.slice(1).replace('module', ' Module')}`}
        >
          {activeTab === 'module' && (
            <form onSubmit={handleSaveModule} noValidate
              className={validated ? "was-validated" : ""}

            >
              <div className="mb-4">
                <label className="form-label text-muted small fw-bold">Module Name</label>
                <input type="text" className="form-control rounded-3 bg-light p-3 shadow-none"
                  placeholder="e.g. Human Resource" value={addEditPerm?.name}
                  onChange={(e) => setAddEditPerm(prev => ({ ...prev, name: e.target.value }))}
                  required />
                <div className="invalid-feedback">Module name is required.</div>
              </div>
              <div className="d-flex gap-2 justify-content-end mt-4">
                <button type="button" className="btn btn-light rounded-pill px-4" onClick={closeModal}>Cancel</button>
                <button type="submit" className="btn btn-primary rounded-pill px-4"
                  disabled={isAdding}
                ><Save size={16} className="me-2" />{addEditPerm.parentName ? 'Update' : 'Save'}</button>
              </div>
            </form>
          )}


          {activeTab === 'submodule' && (
            <form onSubmit={handleSaveModule}
              noValidate
              className={validated ? "was-validated" : ""}
            >
              <div className="mb-3">
                <label className="form-label text-muted small fw-bold">Select Module</label>
                <select className="form-select rounded-3 bg-light p-3 shadow-none"
                  style={{ height: '48px' }}
                  value={addEditPerm.parentName}
                  onChange={(e) => setAddEditPerm(prev => ({ ...prev, parentName: e.target.value }))} required>
                  <option value="">-- Choose Parent --</option>
                  {dropDownData?.map(m => <option key={m?.module} value={m?.module}>{m?.module}</option>)}
                </select>
                <div className="invalid-feedback">Select Module.</div>
              </div>
              <div className="mb-4">
                <label className="form-label text-muted small fw-bold">Sub Module Name</label>
                <input type="text" className="form-control rounded-3 bg-light p-3 shadow-none" placeholder="e.g. Payroll" value={addEditPerm.name}
                  onChange={(e) => setAddEditPerm(prev => ({ ...prev, name: e.target.value }))}
                  required />
                <div className="invalid-feedback">Enter Sub Module.</div>
              </div>
              <div className="d-flex gap-2 justify-content-end mt-4">
                <button type="button" className="btn btn-light rounded-pill px-4" onClick={closeModal}>Cancel</button>
                <button type="submit" className="btn btn-primary rounded-pill px-4"
                  disabled={isAdding}
                ><Save size={16} className="me-2" />{addEditPerm?.id ? 'Update' : 'Save'}</button>
              </div>
            </form>
          )}


          {activeTab === 'permission' && (
            <form
              onSubmit={handleSaveModule}
              noValidate
              className={validated ? "was-validated" : ""}>
              {/* <div className="mb-3">
                <label className="form-label text-muted small fw-bold">Select Module</label>
                <select className="form-select rounded-3 border-0 bg-light p-3 shadow-none" value={permForm.moduleId} onChange={(e) => setPermForm({ ...permForm, moduleId: e.target.value, subModuleId: '' })} required>
                  <option value="">-- Choose Module --</option>
                  {modules.map(m => <option key={m.id} value={m.id}>{m.name}</option>)}
                </select>
              </div> */}
              <div className="mb-3">
                <label className="form-label text-muted small fw-bold">Select Sub Module</label>
                <select className="form-select rounded-3 bg-light p-3 shadow-none"
                  style={{ height: '48px' }}
                  value={addEditPerm?.parentName} onChange={(e) => setAddEditPerm({ ...addEditPerm, parentName: e.target.value })}
                  required>
                  <option value="">-- Choose Sub Module --</option>
                  {dropDownData?.map(sm => <option key={sm?.submodule} value={sm?.submodule}>{sm?.submodule}</option>)}
                </select>
                <div className="invalid-feedback">Select Sub Module.</div>
              </div>
              <div className="mb-4">
                <label className="form-label text-muted small fw-bold">Permission Name</label>
                <input type="text" className="form-control rounded-3 bg-light p-3 shadow-none" placeholder="e.g. Edit Records"
                  value={addEditPerm?.name} onChange={(e) => setAddEditPerm({ ...addEditPerm, name: e.target.value })}
                  required />
                <div className="invalid-feedback">Enter Permission Name.</div>
              </div>
              <div className="d-flex gap-2 justify-content-end mt-4">
                <button type="button" className="btn btn-light rounded-pill px-4" onClick={closeModal}>Cancel</button>
                <button type="submit" className="btn btn-primary rounded-pill px-4"
                  disabled={isAdding}
                ><Save size={16} className="me-2" />{addEditPerm?.id ? 'Update' : 'Save'}</button>
              </div>
            </form>
          )}
        </Modal>


      </div>
    </Layout >

  )
}

export default PermissionManagement